import { SocialShare } from '@effectivastudio/lit-components/components/social_share/element.js';

SocialShare.config.icons = {
  facebook: 'facebook-f:brands',
  twitter: 'twitter:brands',
  whatsapp: 'whatsapp:brands',
  share: 'share-alt',
};
